// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audit-compliance-map {
    margin: 0;
    padding: 10px 12px 12px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.06);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.audit-compliance-map--demo {
    border-style: dashed;
    border-color: rgba(192, 159, 83, 0.22);
}

.audit-compliance-map--loading {
    opacity: 0.65;
    pointer-events: none;
}

.audit-compliance-map__header {
    margin-bottom: 8px;
}

.audit-compliance-map__title {
    display: block;
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #9a9a9a;
    margin-bottom: 4px;
}

.audit-compliance-map__subtitle {
    display: block;
    font-size: 0.65rem;
    line-height: 1.35;
    color: #6a6a6a;
}

.audit-compliance-map__map-shell {
    position: relative;
    flex: 1 1 auto;
    width: 100%;
    min-height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: visible;
}

.audit-compliance-map__map-shell .audit-compliance-world-map {
    width: 100%;
    height: 100%;
    flex: 0 1 auto;
}

.audit-compliance-map__legend {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 14px;
    list-style: none;
    margin: 8px 0 0;
    padding: 0;
    justify-content: center;
}

.audit-compliance-map__legend-item {
    font-size: 0.6rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    padding: 3px 8px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    color: #777;
    background: rgba(0, 0, 0, 0.15);
}

.audit-compliance-map__legend-item--observed {
    border-color: rgba(120, 200, 145, 0.4);
    color: #9dd4ae;
}

.audit-compliance-map__legend-item--watch {
    border-color: rgba(230, 175, 80, 0.4);
    color: #e8c070;
}

.audit-compliance-map__legend-item--risk {
    border-color: rgba(235, 110, 110, 0.45);
    color: #e89898;
}

.audit-compliance-map__legend-item--potential {
    border-color: rgba(201, 160, 87, 0.45);
    color: #d4a574;
}
`, "",{"version":3,"sources":["webpack://./src/Components/AuditSnapshotCard/AuditComplianceMiniMap.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;IAC9B,2CAA2C;IAC3C,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,oBAAoB;IACpB,2CAA2C;IAC3C,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,uCAAuC;IACvC,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,cAAc;AAClB","sourcesContent":[".audit-compliance-map {\n    margin: 0;\n    padding: 10px 12px 12px;\n    border-radius: 10px;\n    background: rgba(0, 0, 0, 0.2);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n}\n\n.audit-compliance-map--demo {\n    border-style: dashed;\n    border-color: rgba(192, 159, 83, 0.22);\n}\n\n.audit-compliance-map--loading {\n    opacity: 0.65;\n    pointer-events: none;\n}\n\n.audit-compliance-map__header {\n    margin-bottom: 8px;\n}\n\n.audit-compliance-map__title {\n    display: block;\n    font-size: 0.68rem;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: #9a9a9a;\n    margin-bottom: 4px;\n}\n\n.audit-compliance-map__subtitle {\n    display: block;\n    font-size: 0.65rem;\n    line-height: 1.35;\n    color: #6a6a6a;\n}\n\n.audit-compliance-map__map-shell {\n    position: relative;\n    flex: 1 1 auto;\n    width: 100%;\n    min-height: 120px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: visible;\n}\n\n.audit-compliance-map__map-shell .audit-compliance-world-map {\n    width: 100%;\n    height: 100%;\n    flex: 0 1 auto;\n}\n\n.audit-compliance-map__legend {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px 14px;\n    list-style: none;\n    margin: 8px 0 0;\n    padding: 0;\n    justify-content: center;\n}\n\n.audit-compliance-map__legend-item {\n    font-size: 0.6rem;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    padding: 3px 8px;\n    border-radius: 999px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    color: #777;\n    background: rgba(0, 0, 0, 0.15);\n}\n\n.audit-compliance-map__legend-item--observed {\n    border-color: rgba(120, 200, 145, 0.4);\n    color: #9dd4ae;\n}\n\n.audit-compliance-map__legend-item--watch {\n    border-color: rgba(230, 175, 80, 0.4);\n    color: #e8c070;\n}\n\n.audit-compliance-map__legend-item--risk {\n    border-color: rgba(235, 110, 110, 0.45);\n    color: #e89898;\n}\n\n.audit-compliance-map__legend-item--potential {\n    border-color: rgba(201, 160, 87, 0.45);\n    color: #d4a574;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
